import Vue from 'vue'
import Router from 'vue-router'

// 解决 vue-router.esm.js Uncaught (in promise)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

import contractApproval from '@/pages/approval/contractApproval' //合同
import commissionAgreementApprova from '@/pages/approval/commissionAgreementApprova' //佣金
import financeApproval from '@/pages/approval/financeApproval' //账单
import success from '@/pages/approval/success'
import parkingApproval from '@/pages/approval/parkingApproval' //停车
import intentionApproval from '@/pages/approval/intentionApproval' //意向
import file from '@/pages/approval/file'

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_APP_HOST ? '' : '/tcqytest/',
  fallback: true,
  routes: [
    {
      path: '/',
      redirect: '/contractApproval'
    },
    {
      path: '/contractApproval',
      name: 'contractApproval',
      component: contractApproval,
      meta: {
        title: '合同审批',
        index: 0
      }
    },
    {
      path: '/commissionAgreementApprova',
      name: 'commissionAgreementApprova',
      component: commissionAgreementApprova,
      meta: {
        title: '佣金协议审批',
        index: 0
      }
    },
    {
      path: '/financeApproval',
      name: 'financeApproval',
      component: financeApproval,
      meta: {
        title: '财务审批',
        index: 0
      }
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/parkingApproval',
      name: 'parkingApproval',
      component: parkingApproval,
      meta: {
        title: '车位审批',
        index: 0
      }
    },
    {
      path: '/intentionApproval',
      name: 'intentionApproval',
      component: intentionApproval,
      meta: {
        title: '意向协议审批',
        index: 0
      }
    },
    {
      path: '/file',
      name: 'file',
      component: file,
      meta: {
        title: '文件',
        index: 0
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop
      // }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})

export default router
